import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../authContext";
import { enableInternalFleetTools } from "../../../config/env";


const isAmptransEmail = (email) => String(email || "").trim().toLowerCase().endsWith("@amptrans.net");


export default function FleetInternalGate({ children }) {
  const { currentUser } = useAuth();
  const allowed = enableInternalFleetTools && isAmptransEmail(currentUser?.email);
  if (!allowed) {
    return <Navigate to="/fleet/dashboard" replace />;
  }
  return children;
}
